import React from 'react';
import { up } from 'styled-breakpoints';
import styled from 'styled-components';
import { hexToRgba, pxToRem } from '../../../styles/utils';
import loader from '../../../assets/gifs/loader.gif';

export default function FullPageLoader() {
  return (
    <FullPageLoaderWrapper>
      <LoaderWrapper>
        <Loader>
          <img src={loader} />
        </Loader>
      </LoaderWrapper>
    </FullPageLoaderWrapper>
  );
}

const FullPageLoaderWrapper = styled.div`
  background-color: ${(props) => hexToRgba(props.theme.palette.black, 0.4)};
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 1070;
  display: flex;
  justify-content: center;
`;

const LoaderWrapper = styled.div`
  margin: ${pxToRem(320)} ${pxToRem(150)};
  ${up('md')} {
    margin: ${pxToRem(400)} ${pxToRem(800)};
  }
`;

const Loader = styled.div`
  width: ${pxToRem(62)};
  height: ${pxToRem(62)};
`;
